export default __webpack_public_path__ + "static/media/Email.69116b70.png";